import { SupportAdminDetailContainer } from "../../containers/SupportSystem/Admin/SupportAdminDetailContainer";
export function SupportAdminDetailPage () {
    return(
       <SupportAdminDetailContainer/>
    )
}